import { ISubmissionHomePayload, IValidationResponsePayload, ICurrentSubAuths, ISubmissionHomeText, IUploadSection, IUserAction } from "../../../../DataClasses/SubmissionData";
import { ValidationError } from "../../../../DataClasses/SharedData";

export interface IFileUploadData {
    savedName: string;
    originalName: string;
    component: string;
    validationStatus: string;
    createUser: string;
    createDate: string;
}

export interface ISubmissionActivityData {
    date: string;
    user: string;
    message: string;
}

export interface IDetailedSubmissionData {
    key: string;
    value: string;
}

export interface IVendorMeasureData {
    measure: string;
    guid: string;
}

export interface IAuditorData {
    email: string;
    auditLevel: string;
    firstName: string;
    lastName: string;
    actions: string;
}

export interface ISubmissionHomeState {
    submissionData: ISubmissionHomePayload,
    currentSubId: string,
    isMainTabLoading: boolean,
    isGenericActionHappening: boolean,
    isAuditorTabLoading: boolean,
    validation: IValidationResponsePayload,
    currentTabVal: number,
    component: string,
    auths: ICurrentSubAuths,
    users: any[],
    textLookup: ISubmissionHomeText,
    errorMsg: string,
    uploadSection: IUploadSection,
    allAccounts: string[],
    selectedAccount: any,
    selectedAccountLevel: any,
    dialogStatus: IDialogs,
    isHistoryTabLoading: boolean,
    isAllDownloadsTabLoading: boolean,
    history: any[],
    allDownloads: any[],
    isSubmissionActivitiesLoading: boolean,
    isDetailedSubmissionDetailLoading: boolean,
    submissionActivities: any[],
    detailedSubmissionMeta: any[],
    isFlagUpdateSuccessful: boolean,
    isAdminUpdatingAttestFlags: boolean,
    isSysAdmin: boolean,
    isOrgAdmin: boolean,
    attestation: IAttestationState,
    userAction: IUserAction,
    showAllDownloads: boolean,
    redirect: boolean,
    validationResult: any,
    validationDialogOpen: boolean,
    currentValidationItem: ValidationError,
    isVendorMeasureGuidsLoading: boolean,
    vendorMeasureGuids: any[],
    enableHosInterimDataSubmission: boolean,
    isValidationTableLoading: boolean,
    overwriteFile: boolean
}

export interface IAttestationState {
    attestationStarted: boolean,
    attestationTitle: string,
    attestationText: string,
    attestationSigned: boolean
}

export interface IDialogs {
    planLockOpen: boolean,
    planLockTitle: string,
    planLockText: string,
    planLockUndoOpen: boolean,
    planLockUndoTitle: string,
    planLockUndoText: string,
    auditLockOpen: boolean,
    auditLockTitle: string,
    auditLockText: string,
    auditLockUndoOpen: boolean,
    auditLockUndoTitle: string,
    auditLockUndoText: string,
    auditLockNoActionText: string,

    markFinalOpen: boolean,
    markFinalTitle: string,
    markFinalText: string,
    markFinalUndoOpen: boolean,
    markFinalUndoTitle: string,
    markFinalUndoText: string,
    markFinalNoActionText: string,

    attestationUndoOpen: boolean,
    attestationUndoTitle: string,
    attestationUndoText: string,
    attestationNoActionText: string,

    hosAttestationUndoOpen: boolean,

    clearMeasuresOpen: boolean,
    clearMeasuresTitle: string,
    clearMeasuresText: string
}
export interface TabMetadata {
    Label: string,
    AdminOnly: boolean,
    HedisOnly: boolean,
}

// Tab indices
export const SUBMISSION_TAB = 0;
export const AUDIT_REVIEW_TOOL_TAB = 1;
export const AUDITORS_TAB = 2;
export const ALL_DOWNLOADS_TAB = 3;
export const UPLOAD_HISTORY_TAB = 4;
export const CLEAR_ALL_MEASURES = 5;
export const ADMIN_TAB = 6;

// Tab metadata
export const TabInfo: TabMetadata[] = [
    { Label: 'EDIT SUBMISSION', AdminOnly: false, HedisOnly: false },
    { Label: 'AUDITOR REVIEW TABLE', AdminOnly: true, HedisOnly: true },
    { Label: 'AUDITORS', AdminOnly: true, HedisOnly: false },
    { Label: 'ALL DOWNLOADS', AdminOnly: false, HedisOnly: false },
    { Label: 'UPLOAD HISTORY', AdminOnly: false, HedisOnly: false },
    { Label: 'CLEAR ALL MEASURES', AdminOnly: false, HedisOnly: true },
    { Label: 'ADMIN', AdminOnly: true, HedisOnly: false },
];

// Step numbers
export const IMPORT_SUBMISSION_STEP = 1;
export const MARK_FINAL_CAHPS_STEP = 2;
export const PLAN_LOCK_STEP = 3;
export const AUDIT_LOCK_STEP = 4;
export const ATTESTATION_HOS_STEP = 5;
export const MARK_FINAL_HEDIS_HOS_STEP = 6;
export const ATTESTATION_HEDIS_STEP = 7;
export const ATTESTATION_CAHPS_STEP = 8;
export const COMPLETE_STEP = 9;

// Step arrays
export const SubmissionStepsHedis = [
    { Name: 'Import Submission', Number: IMPORT_SUBMISSION_STEP },
    { Name: 'Apply Plan Lock', Number: PLAN_LOCK_STEP },
    { Name: 'Apply Audit Lock', Number: AUDIT_LOCK_STEP },
    { Name: 'Apply Mark Final', Number: MARK_FINAL_HEDIS_HOS_STEP },
    { Name: 'Finalize Attestation', Number: ATTESTATION_HEDIS_STEP },
    { Name: 'Submission Finalized', Number: COMPLETE_STEP }
];
export const SubmissionStepsCahps = [
    { Name: 'Import Submission', Number: IMPORT_SUBMISSION_STEP },
    { Name: 'Apply Mark Final', Number: MARK_FINAL_CAHPS_STEP },
    { Name: 'Finalize Attestation', Number: ATTESTATION_CAHPS_STEP },
    { Name: 'Submission Finalized', Number: COMPLETE_STEP }
];
export const SubmissionStepsHos = [
    { Name: 'Import Submission', Number: IMPORT_SUBMISSION_STEP },
    { Name: 'Validations/Attestation', Number: ATTESTATION_HOS_STEP },
    { Name: 'Apply Mark Final', Number: MARK_FINAL_HEDIS_HOS_STEP },
    { Name: 'Submission Finalized', Number: COMPLETE_STEP }
];
export const SubmissionStepsDqs = [
    //{ Name: 'Import Submission', Number: IMPORT_SUBMISSION_STEP },
    //{ Name: 'Submission Finalized', Number: COMPLETE_STEP }
];

